module.exports = __webpack_public_path__ + "static/media/logo.745cca27.png";